module.exports = __webpack_public_path__ + "images/trading-psychology-34abff.png";